import React from 'react';
import { useSelector } from 'react-redux';

import { Box, Card, Chip, CardActionArea, LinearProgress, Typography } from '@mui/material';
import * as UIAction from '../../redux/actions/ui.actions';
import * as Utils from './TargetCardUtil';
import { isEntityLinked } from '../../api/client';
import { getLogoUrl } from '@hotglue/common';
import { Alert } from '../popupAlerts';

const TargetCard = ({ target, hasLinked }) => {
  const { version, label, target: targetId } = target;
  const [isLoading, setLoading] = React.useState(false);
  const icon = getLogoUrl(target);

  const demo = useSelector((state) => state.configuration.demo || state.preferences.demoMode);
  const flow = useSelector((state) => state.flows.selectedFlow);

  const preLink = async () => {
    if (hasLinked) {
      Alert({ text: 'Disconnect linked target before switching to another', type: 'error' });
      return;
    }

    if (demo) {
      Alert({ type: 'info', text: `Sorry, you can't connect sources in demo mode!` });
      return;
    }

    setLoading(true);

    // // Check if entity is already linked in another flow
    isEntityLinked(targetId).then((oFlows) => {
      const filteredFlows = Array.isArray(oFlows) && oFlows.filter((f) => f.id !== flow);
      if (filteredFlows && filteredFlows.length > 0) {
        setLoading(false);

        // Ask if they want to copy tap config from one of these
        UIAction.showCopyEntity(target, oFlows, 'target');
      } else {
        Utils.doLink(target).then(() => {
          setLoading(false);
        });
      }
    });
  };

  return (
    <Card
      elevation={0}
      sx={{
        height: '160px',
        border: ({ palette }) => `1px solid ${palette.common.outline}`,
        opacity: hasLinked ? 0.5 : 1,
      }}
    >
      {isLoading && <LinearProgress />}
      <CardActionArea
        id="SupportedTargetCard"
        disabled={hasLinked}
        onClick={preLink}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          gap: 2,
          position: 'relative',
        }}
      >
        <Box component="img" role={'img'} alt={`image for ${label} target`} src={icon} width="48px" height="48px" sx={{ objectFit: 'contain' }} />
        <Typography variant="h2">{label}</Typography>
        {version && (
        <Box sx={{
          position: "absolute",
          bottom: 10,
          right: 10
        }}>
          <Chip
            label={version}
            size="small"
            sx={{ color: '#676767', fontSize: '10px', height: '18px', fontWeight: '300' }}
          />
        </Box>
        )}
      </CardActionArea>
    </Card>
  );
};

export default TargetCard;
